<div class="observationsContent col-12 p-0 pb-4 d-flex align-items-end row IEm-0 m-0" [ngClass]="{'viewMode': observationService.enableView}">
  <div class="modeTitle">{{modes[mode] | translate}}</div>

  <div class="p-0 col-12 mb-3 categories-div">
    <h1 class="section-title mb-2">{{ "CONFIGURE.PROFESSIONAL_CATEGORY" | translate }}</h1>
    <div class="categories-section">
      <!-- <p class="section-label">{{'SOP_OBSERVATION.QUICK_COMMENTS' | translate}}</p> -->
      <div class="categories-container">
        <ul class="category-tag mb-0" >
          <li *ngFor="let category of categories;" [ngClass]="category?.isSelected ? 'active' : '' " (click)="tappedCategory(category)">
            {{category.categoryName | translate | labelSanitizer }} <i *ngIf="category.isSelected" class="d-flex closeTagIcon"></i></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="p-0 col-12 categories-div" *ngIf="showProfessionalSubcategory && (selectedSubcategories?.length > 0)">
    <h1 class="section-title mb-2">{{ "CONFIGURE.PROFESSIONAL_SUB_CATEGORY" | translate }}</h1>
    <div class="subcategories-section" >
      <!-- <p class="section-label">{{'SOP_OBSERVATION.QUICK_COMMENTS' | translate}}</p> -->
      <div class="subcategories-container" >
        <ul class="category-tag mb-0">
          <li  *ngFor="let subcategory of selectedSubcategories;" [ngClass]="subcategory?.isSelected ? 'active' : '' " (click)="tappedSubCategory(subcategory)">
            {{layoutService.getSubCategoryName(subcategory) | translate}} <i *ngIf="subcategory.isSelected" class="d-flex closeTagIcon"></i></li>
        </ul>
      </div>
    </div>
  </div>
  <hr class="occupations-separator">
  <div class="moments-section">
    <div class="moments">
      <h1 class="section-title mb-2 fiveMomentHead">{{ translationKeys.Observation.SelectMoments | translate }}</h1>
      <div class="fiveMomentUl">
        <div class="momentDiv" [ngClass]="(!activemoments[i]) ? '' : 'active pos'+i " 
          *ngFor="let action of fivemoments;let i = index"
          (click)="momentsActive(i,asepticModal,action.name,$event)">
          <!-- [ngClass.class2]="{'aseptic-selected': (i==1 && asepticActionId > 0)} -->
          <a>
            <label>
              <input type="checkbox" hidden >
              <div class="momentCard-top">
                <span class="col-12 p-0 d-flex justify-content-between align-items-center">
                  <span class="count">{{i+1}}.</span>
                  <img [src]="action.img">
                  <img [src]="action.activeimg" class="active">
                </span>
                <span class="col-12 p-0 card-task-desc active align-items-center">
                  {{action.name | translate}}</span>
              </div>
              <div class="momentCard-bottom d-flex" *ngIf="i === 1 && asepticActionId > 0">
                <span class="col-10 procText" >{{asepticprocedureName | translate}}</span>
                <!-- <span class="col-2 d-flex" *ngIf="i === 1">
                  <img class="asepticMore" src="assets/ph-bhp-observeobservation/svg/more.svg">
                  <img class="asepticMore active" src="assets/ph-bhp-observeobservation/svg/active-more.svg">
                </span> -->
              </div>
            </label>
          </a>
        </div>
      </div>
    </div>

    <div class="actions">
      <h1 class="section-title mb-2">
        {{ translationKeys.Observation.SelectActions | translate }}
      </h1>

      <div class="actionUl-div">
        <!-- Handwash, Handrub, Missed -->
        <ng-container *ngFor="let action of actions; let i = index">
          <div
            class="actionDiv d-flex"
            *ngIf="i < 3"
            [ngClass]="{
              'active': activeIndex[i],
              'd-none': i === 0 && !handWashingEnabled,
              'slot-3': !handWashingEnabled,
              'slot-4': handWashingEnabled
            }"
            (click)="buttonActive(i, $event, action.name)"
          >
            <label class="d-flex w-100">
              <input type="checkbox" id="checkbox-{{ i }}" hidden />
              <span class="card-task-desc col-9 active">{{ action.name | translate }}</span>
              <span class="card-media col-3 p-0">
                <img [src]="action.img" />
                <img [src]="action.activeimg" class="active" />
              </span>
            </label>
          </div>
        </ng-container>

        <!-- Gloves + Unavailable: un SOLO slot (mismo ancho que un actionDiv) -->
        <div
          class="actionDiv gloves-unavailable-group d-flex"
          [ngClass]="{
            'slot-3': !handWashingEnabled,
            'slot-4': handWashingEnabled
          }"
        >
          <!-- MITAD: Gloves -->
          <div
            class="half-action"
            [ngClass]="{ 'active': enableGloves && activeIndex[3], 'bgGray': !enableGloves }"
            (click)="enableGloves && buttonActive(3, $event, actions[3].name)"
          >
            <label class="d-flex w-100">
              <input type="checkbox" id="checkbox-3" hidden [disabled]="!enableGloves" />
              <span class="card-task-desc col-9 active">{{ actions[3].name | translate }}</span>
              <span class="card-media col-3 p-0">
                <img [src]="actions[3].img" />
                <img [src]="actions[3].activeimg" class="active" />
              </span>
            </label>
          </div>

          <!-- MITAD: Unavailable -->
          <div
            class="half-action"
            [ngClass]="{ 'active': enableUnavailable && activeIndex[4], 'bgGray': !enableUnavailable }"
            (click)="enableUnavailable && buttonActive(4, $event, actions[4].name)"
          >
            <label class="d-flex w-100">
              <input type="checkbox" id="checkbox-4" hidden [disabled]="!enableUnavailable" />
              <span class="card-task-desc col-9 active">{{ actions[4].name | translate }}</span>
              <span class="card-media col-3 p-0">
                <img [src]="actions[4].img" />
                <img [src]="actions[4].activeimg" class="active" />
              </span>
            </label>
          </div>
        </div>
      </div>

    </div>
  </div>
  <hr class="observe-separator">
  <div class="comments-section">
    <div class="predefinedSection">
      <h1 class="section-title mb-2">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h1>
      <div class="comment-bottom">
        <!-- <p class="section-label">{{'SOP_OBSERVATION.QUICK_COMMENTS' | translate}}</p> -->
        <div class="quick-cmt-contain">
          <ul class="quick-cmt mb-0">
            <li  *ngFor="let tagComment of tagComments;" [ngClass]="tagComment.isSelected ? 'active' : '' " (click)="tappedComment(tagComment)">
              {{tagComment.comment | translate}} <i *ngIf="tagComment.isSelected" class="d-flex closeTagIcon"></i></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="freeTextSection">
      <div class="comments-container h-100">
        <label class="comments-label">{{'CONFIGURE.WRITE_COMMENTS_HERE' | translate}}</label>
        <textarea inputSanitizer class="text-comt bgWhite form-control" [(ngModel)]="userComment" rows="1" type="text"
          maxlength="500" (keydown)="onCommentsKeyDown($event)" [disabled]="observationService.enableView"></textarea>
      </div>
    </div>
</div>
</div>

<ng-template #asepticModal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{'OBSERVATION.BEFORE.CLEAN_ASEPTIC_PROCEDURES' | translate}}</h5>
    <a class="cursor" (click)="getAscepticProceturevalue('close');"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body" data-simplebar *ngFor="let value of asepticprocedures;let i = index">
    <div class="form-check">
      <input class="form-check-input" name="asepticSteps-{{i}}" [checked]="asepticActionId === value.id" id="customRadio-{{i}}"
        (change)="changeAsepticProcedure(value.id); getAscepticProceturevalue('close');" [(ngModel)]="asepticActionId"
        [ngModelOptions]="{standalone: true}" type="radio" [value]="value.id">
      <label class="form-check-label" for="customRadio-{{i}}">{{value.value | translate}}</label>
    </div>
  </div>
</ng-template>
